import styled, { css } from 'styled-components';
import {
  flexbox,
  alignItems,
  flexDirection,
  alignSelf,
  justifyContent
} from '../../styles/helpers/flexbox';
import ThemeHelper from '../../themes/theme-helper';

export const AssignLearningJourneysWrapper = styled.div((props) => {
  const { colours } = ThemeHelper.getTheme(props);
  return `
    ${flexbox()}
    ${flexDirection('column')}
    ${justifyContent('space-between')}

    width: ${props.showStudentLJ ? 63 : 100}%;
    border-top: ${props.showStudentLJ ? 0 : 1}px solid ${colours.grey[100]};
    border-radius:${props.showStudentLJ ? 0 : 8}px;
    margin: 0;
    margin-top: ${props.showStudentLJ ? 10 : 0}px;
    margin-right: ${props.showStudentLJ ? -10 : 0}px;

    .preview-button {
      padding: 4px 8px;
      white-space: nowrap;
    }
  `;
});

export const Header = styled.span((props) => {
  const { typography } = ThemeHelper.getTheme(props);
  return `
    ${alignSelf('flex-start')}

    font-size: ${typography.modalTitle.size};
    margin: 1em 25px 0.5em 25px;
  `;
});

export const Body = styled.div((props) => {
  const { typography } = ThemeHelper.getTheme(props);
  return `
    ${flexbox()}
    ${flexDirection('column')}

    font-size: ${typography.size};
  `;
});

export const Footer = styled.div`
  ${alignSelf('flex-end')}

  margin: 1em;

  .button {
    padding-right: 2em;

    &:hover {
      filter: none;
    }

    .isvg {
      padding: 0 1em 0 0;
      width: 15px;
      height: 15px;

      * {
        color: white;
      }
    }
  }
`;

export const LearningJourneyRowWrapper = styled.div(props => `
  background-color: rgba(234, 249, 249, 0.6);
  padding: 10px ${props.showStudentLJ ? 5 : 25}px;


  :nth-child(2n) {
    background-color: rgba(231, 233, 234, 0.6);
  }

  > :nth-child(2) {
    margin-left: 10px;
    width: ${props.showStudentLJ ? 25 : 40}%;
    text-align: left;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  > :nth-child(3) {
    width: 5%;
    margin-left: ${props.showStudentLJ ? 2 : 5}%;
    margin-right: ${props.showStudentLJ ? 3 : 10}%;
  }

  > :last-child {
    font-size: 12px;
    cursor: pointer;
    position: relative;
    margin-left: ${props.showStudentLJ ? 0 : 25}px;

    > div,
    div::after {
      position: absolute;
    }

    div::after {
      top: -10px;
    }
  }

  .button {
    height: 21px;
    font-size: 12px;

    &:hover {
      filter: none;
    }

    .isvg {
      height: 1em;
      width: 1em;
    }

    svg {
      path {
        fill: white !important;
      }
    }
  }

  ${flexbox()}
  ${alignItems('center')}
  ${justifyContent('space-between')}
`);

export const Info = styled.div((props) => {
  const { typography } = ThemeHelper.getTheme(props);
  return `
    ${flexbox()}
    ${flexDirection('column')}

    padding: 10px;
    font-size: ${typography.size};

    .heading {
      margin-bottom: 5px;
    }
  `;
});

export const InfoRowWrapper = styled.div(props => css`
  ${flexbox()}
  ${justifyContent('space-between')}

  > :first-child {
    width: 16ch;
    text-align: left;
  }

  > :nth-child(2) {
    width: 10%;
  }

  > :last-child {
    width: ${props.showStudentLJ ? 4 : 9}ch;
    text-align: right;
    color: #900012;
  }
`);

export const LearningJourneyEmptyRow = styled.div(props => `
  background-color: rgba(234, 249, 249, 0.6);
  padding: 10px ${props.showStudentLJ ? 5 : 25}px;
  height: 20px;
  text-align: center;

  :nth-child(2n) {
    background-color: rgba(231, 233, 234, 0.6);
  }
`);
